module.exports = __webpack_public_path__ + "static/media/member_black.04c5017f.svg";